module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.checkboxesPosition === 'right-side' || _vm.productType) ? _c('div', {
    staticClass: "filter-header-web right-side"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Filter by:")]), _vm._v(" "), (!_vm.productType) ? _c('div', [_c('EcommerceFilterProductType')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "categories"
  }, [_c('EcommerceFilterCategories', {
    attrs: {
      "categorySelection": _vm.categorySelection,
      "preSelectedCategories": _vm.preSelectedCategories
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkboxesPosition === 'below' && !_vm.productType) ? _c('div', {
    staticClass: "filter-header-web below"
  }, [_c('div', {
    staticClass: "product-type"
  }, [_c('div', [_vm._v("Filter by:")]), _vm._v(" "), _c('div', [_c('EcommerceFilterProductType')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "categories"
  }, [_c('EcommerceFilterCategories', {
    attrs: {
      "preSelectedCategories": _vm.preSelectedCategories
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-header-mobile"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileFilter = !_vm.showMobileFilter
      }
    }
  }, [_c('span', [_vm._v("Filter")]), _vm._v(" "), (_vm.showMobileFilter) ? _c('span', [_c('i', {
    staticClass: "fas fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), (!_vm.showMobileFilter) ? _c('span', [_c('i', {
    staticClass: "fas fa-chevron-up"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.showMobileFilter) ? _c('div', [(!_vm.productType) ? _c('EcommerceFilterProductType') : _vm._e(), _vm._v(" "), _c('EcommerceFilterCategories', {
    attrs: {
      "categorySelection": _vm.categorySelection
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97e3dc60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/ecommerce/filter/Header.vue
// module id = 712
// module chunks = 0